import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"icon-list__container\" ...attributes>\n  {{yield (hash List=(component \"icon-list/list\") SectionTitle=(component \"icon-list/section-title\"))}}\n</div>", {
  moduleName: "@qonto/ui-kit/components/icon-list/container.hbs"
});